import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { useLocalization } from '@shared-ui/localization-context';
import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';

import { CurrentHotelStore } from 'src/common/stores/current-hotel-store';

import { AvailabilityWizard, AvailabilityWizardProps } from 'components/infosite/rooms-and-rates/availability-wizard';
import { SharedUiDatedForm } from 'components/infosite/shared-ui/form/shared-ui-forms';

interface SearchWizardComposerProps {
  currentHotel?: CurrentHotelStore;
  isMultiItem?: any;
  onUpdateResults?: any;
  onUpdateResultsAvailabilityWizard: any;
}

export const SearchWizardComposer: React.FunctionComponent<SearchWizardComposerProps> = ({
  isMultiItem,
  onUpdateResults,
  onUpdateResultsAvailabilityWizard,
}) => {
  const { formatText } = useLocalization();

  const availabilityWizardProps: AvailabilityWizardProps = {
    currentHotelOnly: true,
    onUpdateResults: onUpdateResultsAvailabilityWizard,
  };

  if (isMultiItem) {
    return null;
  }

  return (
    <Viewport>
      <ViewSmall>
        <AvailabilityWizard {...availabilityWizardProps} />
      </ViewSmall>
      <ViewLarge>
        <React.Fragment>
          <ErrorBoundary label="hotel.information.rooms.availabilityWizard">
            <div data-stid="section-hotel-search">
              <h3 className="is-visually-hidden">{formatText('hotels.infosite.availabilityWizard.changeSearch.a11yLabel')}</h3>
              <SharedUiDatedForm onChange={criteria => onUpdateResults(null, criteria, false)} />
            </div>
          </ErrorBoundary>
        </React.Fragment>
      </ViewLarge>
    </Viewport>
  );
};

SearchWizardComposer.displayName = 'SearchWizardComposer';
